import { ExpandableSidebar, Wrapper } from 'retro';
import AllTicket from './AllTicket';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import ROLES from 'App/Constants/Roles';
import RBAC from 'App/HOCs/RBAC';
import BillPaymentTicket from './BillPaymentTicket';
import ApTicket from './ApTicket';

export default function SupportTicket() {
  const History = useHistory();
  const location = useLocation();
  return (
      <div className='flex h-100h w-100'>
        <ExpandableSidebar
          items={[
            {
              title: 'Actions',
              actions: [
                {
                  title: 'All Tickets',
                  active: location.pathname === '/app/supportTickets',
                  onClick: () => {
                    History.push('/app/supportTickets');
                  },
                },
                // {
                //   title: 'Bill Payments',
                //   active: location.pathname === '/app/supportTickets/billPayment',
                //   onClick: () => {
                //     History.push('/app/supportTickets/billPayment');
                //   },
                // },
                {
                  title: 'Account Payables',
                  active: location.pathname === '/app/supportTickets/accountPayables',
                  onClick: () => {
                    History.push('/app/supportTickets/accountPayables');
                  },
                }
              ],
            },
          ]}
        />
        <Switch>
          <Route path='/app/supportTickets' exact>
            <Wrapper>
             <AllTicket/>
            </Wrapper>
          </Route>
          <Route path='/app/supportTickets/billPayment' exact>
            <Wrapper>
              <BillPaymentTicket/>
            </Wrapper>
          </Route>
          <Route path='/app/supportTickets/accountPayables' exact>
            <Wrapper>
             <ApTicket/>
            </Wrapper>
          </Route>
        </Switch>
      </div>
  );
}
